<template>
	<div>
		<!--Loading-->
		<b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

		<PageTitle title="Users" />
		<div class="columns">
			<div class="column is-12">
				<div class="card">
					<div class="card-content">
						<b-table :paginated="true" :per-page="10" :pagination-simple="true" :data="fetchUsers">
							<b-table-column v-slot="props" field="name" label="Name"><small>{{props.row.name}}</small></b-table-column>
							<b-table-column v-slot="props" field="email" label="Email"><small>{{props.row.email}}</small></b-table-column>
							<b-table-column v-slot="props" field="mobile" label="Mobile"><small>{{props.row.mobile}}</small></b-table-column>
							<b-table-column v-slot="props" field="created_at" label="Registered">
								<small>{{$common.formatDate(props.row.created_at)}}</small>
							</b-table-column>
							<b-table-column v-slot="props" field="no_kids" label="Kids"><small>{{props.row.no_kids}}</small></b-table-column>
							<!-- <b-table-column v-slot="props" field="actions" label="Action">
								<b-button @click="$router.push({ name : 'candidatedetail', params : { candidate_id : props.row._id } })" type="is-dark" size="is-small" outlined>Details</b-button>
							</b-table-column> -->
							<template slot="empty">
								<empty-table message="No batches created."></empty-table>
							</template>
						</b-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'

export default {
	name : 'User',
	components : {
		PageTitle, EmptyTable
	},
	data(){
		return {
			isLoading : false
		}
	},
	computed : {
		...mapGetters(['fetchUsers', 'getTeacherToken'])
	},
	methods : {
		...mapActions(['loadUsers']),
	},
	async created(){
		this.isLoading = true
		await this.loadUsers({ token : this.getTeacherToken })
		this.isLoading = false
	}
	
}
</script>